import './index.styl';
import _ from 'lodash';
import template from './index.jst';
import Radio from 'backbone.radio';
import { User } from '../../../../models';
import { TeamFieldCore } from '../../index';

const
	CHANNEL_TRADE = Radio.channel('trade'),
	silent = { silent: true };

/**
 * @description View with list of all players from user's team.
 * Has functionality to trade out and swap players.
 */
export class TradeTeam extends TeamFieldCore {
	get template() {
		return template;
	}

	get className() {
		return 'trade-team';
	}

	ui() {
		return {
			...super.ui(),
			empty_cell: '.player-cell-empty',
		}
	}

	events() {
		return {
			...super.events(),
			'click @ui.btn_trade': 'tradeOutPlayer',
			'click @ui.cancel_substitute': 'onCancelSubstitute',
		}
	}

	initialize() {
		const
			path_url = process.env.AVATARS_PATH + User.get('id');

		this.model.set({
			avatar_url: `${path_url}.png`,
			positions_by_id: {},
			swap_player: {},
			swappable_positions: [],
			filled: {},
			is_coach_enabled: false
		});

		this.initListeners();
	}

	initListeners() {
		this.listenTo(this.model, 'change:lineup', this.render);

		this.listenTo(CHANNEL_TRADE, 'data:changed', this.init);
		this.listenTo(CHANNEL_TRADE, 'check:player', this.checkPredefinedPlayer);

		this.listenTo(CHANNEL_TRADE, 'team:changed', this.onRemovePlayerFromTrade);
		this.listenTo(CHANNEL_TRADE, 'trade:team:available:positions', this.updateTradeLockState);

		return this;
	}
	checkPredefinedPlayer(player_id) {
		if (!player_id) {
			return this;
		}
		const id = parseInt(player_id, 10);
		this.triggerTradeOutPlayer(id);
	}

	updateTradeLockState({ team: size_of_available_trades_form_team }) {
		this.model
			.setTradeLockState(!size_of_available_trades_form_team)
			.trigger('change:lineup');

		return this;
	}

	onRemovePlayerFromTrade({ team, stay_in_trade = [] }) {
		this.model.set({ ...team }, silent);

		stay_in_trade.map(({ id }) => this.model.removePlayer({ id }));

		this.model.setPlayersAvailableForSwap();
		this.updateSwapStates();

		CHANNEL_TRADE.trigger('trade:change:team', this.model.toJSON());

		this.model.trigger('change:lineup');
	}

	tradeOutPlayer(event) {
		event.stopPropagation();

		const
			{ parent } = this.getUIElements(event),
			id = parseInt(parent.dataset.playerId, 10);

		this.triggerTradeOutPlayer(id);
	}

	triggerTradeOutPlayer(id) {
		const player_position = this.model.getPlayerPositionInLineup(id);
		this.model
			.removePlayer({ id })
			.setPlayersAvailableForSwap();

		this.updateSwapStates();

		this.model.trigger('change:lineup');

		this.trigger('trade:out:player', {
			player_id: id,
			team: this.model.toJSON(),
			player_position
		});
	}

	updateSwapStates() {
		const swap_player = this.model.get('swap_player');

		if (swap_player.id && _.size(this.model.empty_positions)) {
			const swappable_positions = _.intersection(
				_.concat(_.clone(swap_player.positions), 'bench'),
				this.model.empty_positions,
			).map(String);

			this.model.set({ swappable_positions }, silent);
		}
		else {
			this.resetSwapState();
		}

		return this;
	}

	resetSwapState() {
		this.model.set({
			swap_player: {},
			swappable_positions: []
		}, silent);

		return this;
	}

	addToSwap({ player, position, index }) {
		const swap_player = {
			...player,
			location: { position, index }
		};

		this.model.set({ swap_player }, silent);

		this.updateSwapStates();

		return this;
	}

	makeSwap({ player, position, index }) {
		this.model.makeSwap([
			{ position, index },
			player.location
		]);

		CHANNEL_TRADE.trigger('trade:swap:player', {
			player,
			team: this.model.toJSON()
		});

		this.resetSwapState();

		return this;
	}

	onSubstitute(event) {
		event.stopPropagation();

		const
			{ parent } = this.getUIElements(event),
			{ playerId, positionId, index: index_str } = parent.dataset,
			player_id = parseInt(playerId, 10),
			position = parseInt(positionId, 10) || positionId,
			index = parseInt(index_str, 10),
			player_in_swap = this.model.get('swap_player');

		if (player_in_swap.id) {
			this.makeSwap({
				player: player_in_swap,
				position, index
			});
			this.model.setPlayersAvailableForSwap();
		}
		else {
			this.addToSwap({
				player: this.model.getPlayerById(player_id),
				position, index
			});
		}

		this.model.trigger('change:lineup');
	}

	onCancelSubstitute() {
		this.resetSwapState();
		this.model.trigger('change:lineup');
	}
}

export default TradeTeam;